import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * File.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class File extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            name: {},
            url: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][File] organizationId is mandatory');
        }
        return `/sites/organizations/${organizationId}/files/gallery`;
    }
}
